module.exports = __webpack_public_path__ + "static/assets/ed3fe9e11706e76990709ac2e567ada6.svg";